module.exports = __webpack_public_path__ + "img/爱奇艺.d831301d.png";